const upperCase = (event) => {
  const value = event.target.value
    ? event.target.value.toString().toLocaleUpperCase()
    : event.target.value;
  return value;
};
export default upperCase;
